import ColleagueOverview from '../implementations/Views/Colleague/Overview';
import ColleagueCollage from '../implementations/Views/Colleague/Collage';
import VacanciesOverview from '../implementations/Views/Vacancies/Overview';
import VacanciesFrontpage from '../implementations/Views/Vacancies/Frontpage';
import VacanciesFrontpageFilters from '../implementations/Views/Vacancies/FrontpageFilters';
import DepartmentsOverview from '../implementations/Views/Departments/Overview';
import DepartmentsFrontpage from '../implementations/Views/Departments/Frontpage';
import HighlightedEvents from '../implementations/Views/Events/HighlightedEvents';
import AllEvents from '../implementations/Views/Events/AllEvents';

const mappers = {
  views_block__colleagues_block_1: ColleagueOverview,
  views_block__colleagues_block_2: ColleagueCollage,
  views_block__internships_overview: VacanciesOverview,
  views_block__vacancies_overview: VacanciesOverview,
  views_block__vacancies_vacancies_for_department: VacanciesOverview,
  views_block__vacancies_block_1: VacanciesFrontpage,
  views_block__departments_block_1: DepartmentsOverview,
  views_block__vacancies_block_2: VacanciesFrontpageFilters,
  views_block__departments_block_2: DepartmentsFrontpage,
  views_block__events_block_1: HighlightedEvents,
  views_block__events_block_2: AllEvents,
};

export default mappers;
